import { IConcentrations } from '@/interfaces';
import {
  CreateExtractionSequence,
  DefaultEntity,
  ExportExtractionSequencesOptions,
  ExtractionSequenceEntity,
  ValidationExtractionAllowDnaExtraction,
} from '@/types';
import APIService from './axios.service';
import { BaseService } from './base.service';
import { QueryKeysEnum } from '@/enums';
import { streamQuantityEventName } from '@/components/commonComponents/ExportByColumnModal';

class ExtractionSequenceService extends BaseService<
  'extractionSequence',
  ExtractionSequenceEntity,
  DefaultEntity
> {
  constructor() {
    super(QueryKeysEnum.EXTRACTION_SEQUENCE);
  }

  updateConcentration = ({
    id,
    data,
  }: {
    id: string;
    data: IConcentrations;
  }): Promise<void> => {
    return APIService.patch(this.path + '/' + id, data);
  };

  validateKitSerial = (payload: {
    kitId: string; // use Kit serial field
    extractionBatchId: string;
  }): Promise<ValidationExtractionAllowDnaExtraction> => {
    return APIService.post(
      this.path + '/validate-extraction-sequence',
      payload,
    );
  };

  createExtractionSequenceByScanKit = (
    payload: CreateExtractionSequence,
  ): Promise<ExtractionSequenceEntity> => {
    return APIService.post(this.path, payload);
  };

  streamAll = (params: ExportExtractionSequencesOptions) => {
    return APIService.get(this.path + '/stream-data', {
      params,
      responseType: 'stream',
      onDownloadProgress(data) {
        const responseData = data.event?.target?.response || '';
        // Regex to find all progress values
        const regex = /"progress"\s*:\s*(\d+(\.\d+)?)/g;
        const matches = [...responseData.matchAll(regex)];
        // Get the last match
        const lastMatch = matches[matches.length - 1];
        const lastProgress = lastMatch
          ? Math.round(parseFloat(lastMatch[1]))
          : 0;

        // Dispatch quantity for percent progress bar
        window.dispatchEvent(
          new CustomEvent(streamQuantityEventName, {
            detail: { percentProgress: lastProgress },
          }),
        );
      },
    });
  };
}

export const extractionSequenceService = new ExtractionSequenceService();
